document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();
    initLazyIframe();

    function initializeMobileMenu() {
        const offCanvasBtn = document.getElementById('off-canvas-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

        if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
            return;
        }

        function openMenu() {
            mobileMenu.classList.add('open-menu');
        }

        function closeMenu() {
            mobileMenu.classList.remove('open-menu');
        }

        offCanvasBtn.addEventListener('click', openMenu);
        mobileMenuClose.addEventListener('click', closeMenu);

        // Close menu when clicking on links
        menuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });

        // Close menu when clicking outside its area
        window.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
                closeMenu();
            }
        });
    }

    // Popup Adult Warning
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [key, value] = cookie.trim().split('=');
            if (key === name) return value;
        }
        return null;
    }

    function acceptAdult() {
        setCookie("popup_18_hidden", "true", 30);
        document.getElementById('popup').style.display = 'none';
        document.getElementById('page').classList.remove('klofotro-blurred');
    }

    function showUnderagePopup() {
        document.getElementById('popup').style.display = 'none';
        document.getElementById('underage-popup').style.display = 'flex';
    }

    window.onload = function () {
        if (!getCookie("popup_18_hidden")) {
            document.getElementById('popup').style.display = 'flex';
            document.getElementById('page').classList.add('klofotro-blurred');
        }

        document.getElementById('yesButton').addEventListener('click', acceptAdult);
        document.getElementById('noButton').addEventListener('click', showUnderagePopup);
    };
});

/**
 * Lazy load iframe
 */
const initLazyIframe = () => {
    const iframe = document.getElementById('lazy-iframe');
    if (!iframe) {
        console.warn('Lazy iframe not found on the page.');
        return;
    }

    const loadIframe = () => {
        const src = iframe.getAttribute('data-src');
        if (src) {
            iframe.setAttribute('src', src);
            iframe.removeAttribute('data-src');
        }

        removeEventListeners();
    };

    const removeEventListeners = () => {
        document.removeEventListener('mousemove', loadIframe);
        document.removeEventListener('click', loadIframe);
        document.removeEventListener('scroll', loadIframe);
        document.removeEventListener('touchstart', loadIframe);
    };

    document.addEventListener('mousemove', loadIframe, { once: true });
    document.addEventListener('click', loadIframe, { once: true });
    document.addEventListener('scroll', loadIframe, { once: true });
    document.addEventListener('touchstart', loadIframe, { once: true });
};

jQuery(document).ready(function ($) {

});